import React from 'react';
import { formatDuration } from '../utils/latency';

const STEPS = [
  { id: 'opening', label: 'Opening' },
  { id: 'discerning', label: 'Weighing' },
  { id: 'searching', label: 'Searching' },
  { id: 'answering', label: 'Answering' },
];

/**
 * While an answer is being prepared (BRAND_SPEC §9.5 "Thinking"): one status
 * line with AI Rob's grey caret, solid, the steps in words, the time against
 * what this kind of answer usually takes, and the sermons the search has
 * already found. The gradient orb is retired. Only the status line is
 * announced; the ticking timer never is.
 */
function ThinkingCard({ status, tier, elapsedMs, expected, thinking, sources }) {
  const phase = status?.phase || 'opening';
  const label = phase === 'opening' || !status?.label ? 'Reading Rob’s sermons…' : `${status.label}…`.replace(/……$/, '…');
  const activeIndex = Math.max(0, STEPS.findIndex((s) => s.id === phase));
  const p50 = expected?.p50Ms || null;
  const p90 = expected?.p90Ms || null;
  const slow = p90 && elapsedMs > p90 * 1.15;

  return (
    <div className={`thinking-card tier-${tier}`}>
      <p className="thinking-status" role="status" aria-live="polite">
        {label}
        <span className="cv-caret-ai" aria-hidden="true" />
      </p>
      <ol className="thinking-steps" aria-hidden="true">
        {STEPS.map((step, index) => (
          <li key={step.id} className={index < activeIndex ? 'done' : index === activeIndex ? 'current' : ''}>{step.label}</li>
        ))}
      </ol>
      <p className="thinking-meta" aria-hidden="true">
        <span className="thinking-elapsed">{formatDuration(elapsedMs, { decimals: 1 })}</span>
        {p50 ? <> · usually about {formatDuration(p50)}</> : null}
        {' · '}{tier === 'expert' ? 'Deeper' : 'Fast'}
      </p>
      {slow && <p className="thinking-sub">Taking a little longer than usual. Still working on it.</p>}
      {sources?.length > 0 && (
        <p className="thinking-found">
          Found: {sources.slice(0, 3).map((s) => s.title).join(' · ')}{sources.length > 3 ? ` and ${sources.length - 3} more` : ''}
        </p>
      )}
      {thinking && <p className="thinking-thought" aria-hidden="true">{thinking.slice(-220)}</p>}
    </div>
  );
}

export default ThinkingCard;
